'use es6';

import { useEffect } from 'react';
export const useScrollEventListener = listener => {
  useEffect(() => {
    window.addEventListener('scroll', listener);
    return () => window.removeEventListener('scroll', listener);
  }, [listener]);
};